module.exports = __webpack_public_path__ + "img/level-of-difficulty-arrow-up.ea3bf539.svg";